import React, { useEffect } from "react";
import { getBanks } from "../../api/banks";
import { usePaymentStore } from "../../stores/payment";
import { showToastError, showToastSuccess } from "../../services/toast";
import { Select } from "../ui/inputs/Select";
import { Input } from "../ui/inputs/Input";
import { createSlips } from "../../api/slips";
import { useButtonStore } from "../../stores/components/button";
import { ModalProps } from "../../interfaces/modal";
import { ICreateSlip } from "../../interfaces/slips";
import { ModalButton, ModalShell } from "../ui/modals/ModalShell";

const SlipsWithBank: React.FC<ModalProps> = ({ closeModal }) => {
  const {
    formData,
    setFormData,
    banks,
    setBanks,
    updatePaymentBool,
    setUpdatePaymentBool,
  } = usePaymentStore();
  const { setCreateButton } = useButtonStore();

  useEffect(() => {
    getBanks()
      .then((res) => {
        const formattedData = res?.data?.map((data: any) => ({
          label: data.name,
          value: data.id,
        }));

        setBanks(formattedData);
      })
      .catch(() => {
        showToastError("Une erreur est survenue");
      });
  }, []);

  // Gestion des changements de formulaire
  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: parseInt(e.target.value) });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    createSlips(formData as ICreateSlip)
      .then(() => {
        showToastSuccess("Bordereau créé avec succès");
        setCreateButton(false);
        setUpdatePaymentBool(!updatePaymentBool);
        closeModal();
      })
      .catch(() => {
        showToastError("Une erreur est survenue");
      });
  };

  return (
    <ModalShell
      title="Création d'un bordereau"
      subtitle="Merci de renseigner la banque d'encaissement ainsi qu'une date pour la création du bordereau"
      size="md"
      onClose={() => closeModal()}
      footer={
        <>
          <ModalButton variant="secondary" onClick={() => closeModal()}>
            Annuler
          </ModalButton>
          <ModalButton
            variant="primary"
            type="submit"
            onClick={(e) => handleSubmit(e)}
          >
            Créer
          </ModalButton>
        </>
      }
    >
      <div className="grid grid-cols-1 gap-3 font-Nunito sm:grid-cols-2">
        <Select
          label="Banque encaissement"
          name="idBank"
          value={formData.idBank || ""}
          onChange={handleSelectChange}
          fetchOptions={banks}
          className={`disabled:opacity-50 disabled:text-grey-200 cursor-pointer w-full`}
        />
        <Input
          label="Date du bordereau"
          name="date"
          required
          type="date"
          value={formData.date || ""}
          onChange={handleChange}
          clasName="w-full"
        />
      </div>
    </ModalShell>
  );
};

export default SlipsWithBank;
